export default "__VITE_ASSET__Dmg0OkEU__"